// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"5b6bf64e","530":"19c2a629","584":"7acf4b46","638":"faf6a7d0","744":"ee28786a","779":"30cd4707","920":"ab5aba89"}[chunkId] + ".chunk.css";
};